<template>
  <div class="pa-5">
    <v-container>
      <v-row justify-content="space-between">
        <v-col v-for="(item,index) in codeList" :key="index">
          <div v-if="index !== reveal.index">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card class="mx-auto py-5 rounded-xl" max-width="300" :elevation="hover ? 24 : 5">
                  <v-card-title>
                    <v-img :src="select(item)"
                           class="mt-5" width="300" height="200"
                           contain></v-img>
                  </v-card-title>
                  <v-card-text>
                    <div class="text-center text-h6 text-no-wrap text-truncate">
                      {{ item.name }}
                    </div>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="pa-5">
                    <v-btn :color="hover ? 'accent' :''" :elevation="hover ? 5 : 0" block v-clipboard:success="onCopy"
                           v-clipboard:copy="item.code">
                      复制
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-hover>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div>
      <v-bottom-sheet v-model="reveal">
        <v-sheet
            class="text-center"
            height="200px"
        >
          <v-btn
              class="mt-6"
              text
              color="red"
              @click="reveal = false"
          >
            close
          </v-btn>
          <div class="px-15">
            <div>
              {{ chicken }}
            </div>
            <div class="text-right text-h6">
              --- 毒鸡汤
            </div>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <div>
      <v-snackbar
          v-model="snackbar"
          :timeout="message.timeout"
      >
        {{ message.text }}

        <template v-slot:action="{ attrs }">
          <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="snackbar = false"
          >
            关闭
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import {getIdeaCode, getChicken} from '@/api/resources/code'
import {mapMutations} from 'vuex'

export default {
  data: () => ({
    chicken: undefined,
    snackbar: false,
    message: {
      text: '复制成功!',
      timeout: 3000,
    },
    reveal: false,
    codeList: [],
    typeList: [{
      label: require("@/assets/jetbrains/AppCode_icon.png"),
      value: "AppCode"
    }, {
      label: require("@/assets/jetbrains/CLion_icon.png"),
      value: "CLion"
    }, {
      label: require("@/assets/jetbrains/DataGrip_icon.png"),
      value: "DataGrip"
    }, {
      label: require("@/assets/jetbrains/Datalore_icon.png"),
      value: "Datalore"
    }, {
      label: require("@/assets/jetbrains/dotCover_icon.png"),
      value: "dotCover"
    }, {
      label: require("@/assets/jetbrains/dotMemory_icon.png"),
      value: "dotMemory"
    }, {
      label: require("@/assets/jetbrains/dotPeek_icon.png"),
      value: "dotPeek"
    }, {
      label: require("@/assets/jetbrains/dotTrace_icon.png"),
      value: "dotTrace"
    }, {
      label: require("@/assets/jetbrains/IntelliJ_IDEA_icon.png"),
      value: "IntelliJ IDEA"
    }, {
      label: require("@/assets/jetbrains/GoLand_icon.png"),
      value: "GoLand"
    }, {
      label: require("@/assets/jetbrains/Rider_icon.png"),
      value: "Rider"
    }, {
      label: require("@/assets/jetbrains/PhpStorm_icon.png"),
      value: "PhpStorm"
    }, {
      label: require("@/assets/jetbrains/PyCharm_icon.png"),
      value: "PyCharm"
    }, {
      label: require("@/assets/jetbrains/ReSharper_icon.png"),
      value: "ReSharper"
    }, {
      label: require("@/assets/jetbrains/RubyMine_icon.png"),
      value: "RubyMine"
    }, {
      label: require("@/assets/jetbrains/Space_icon.png"),
      value: "Space"
    }, {
      label: require("@/assets/jetbrains/TeamCity_icon.png"),
      value: "TeamCity"
    }, {
      label: require("@/assets/jetbrains/Upsource_icon.png"),
      value: "Upsource"
    }, {
      label: require("@/assets/jetbrains/WebStorm_icon.png"),
      value: "WebStorm"
    }, {
      label: require("@/assets/jetbrains/YouTrack_icon.png"),
      value: "YouTrack"
    }, {
      label: require("@/assets/jetbrains/Kotlin_icon.png"),
      value: "Kotlin"
    }, {
      label: require("@/assets/jetbrains/MPS_icon.png"),
      value: "MPS"
    }, {
      label: require("@/assets/jetbrains/Academy_icon.png"),
      value: "JetBrains Academy"
    }, {
      label: require("@/assets/jetbrains/DataSpell_icon.png"),
      value: "DataSpell"
    }, {
      label: require("@/assets/jetbrains/ReSharperCPP_icon.png"),
      value: "ReSharper C++"
    }, {
      label: require("@/assets/jetbrains/Ktor_icon.png"),
      value: "Ktor"
    }, {
      label: require("@/assets/jetbrains/CodeWithMe_icon.png"),
      value: "Code With Me"
    }, {
      label: require("@/assets/jetbrains/Projector_icon.png"),
      value: "Projector"
    }, {
      label: require("@/assets/jetbrains/Qodana_icon.png"),
      value: "Qodana"
    }, {
      label: require("@/assets/jetbrains/Toolbox_icon.png"),
      value: "Toolbox App"
    }, {
      label: require("@/assets/jetbrains/Fleet_icon.png"),
      value: "Fleet"
    }, {
      label: require("@/assets/jetbrains/RiderFlow_icon.png"),
      value: "RiderFlow"
    }, {
      label: require("@/assets/jetbrains/JetBrains_LicenseVault_icon.png"),
      value: "License Vault"
    }, {
      label: require("@/assets/jetbrains/Aqua_icon.png"),
      value: "Aqua"
    }]
  }),
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    init() {
      this.setLoading()
      Promise.all([this.getCode(), this.show()]).then(([_codeList, _chicken]) => {
        _codeList.forEach(item => {
          let arr = item.label.split('-')
          if (arr.length > 1) {
            item.name = arr[0] + arr[arr.length - 1]
          } else {
            item.name = arr[0]
          }
        })

        this.codeList = _codeList.sort((a, b) => {
          const labelA = this.typeList.findIndex(item => item.value.toLowerCase() === a.label.split('-')[0].toLowerCase());
          const labelB = this.typeList.findIndex(item => item.value.toLowerCase() === b.label.split('-')[0].toLowerCase());

          return labelB - labelA;
        })

        // this.codeList = _codeList
        this.chicken = _chicken
        this.reveal = true
      }).finally(() => {
        this.clearLoading()
      })
    },
    getCode() {
      return new Promise((resolve, reject) => {
        getIdeaCode().then(req => {
          resolve(req.data.data)
        }).catch((e) => {
          reject(e)
        })
      })
    },
    onCopy() {
      this.snackbar = true;
      // this.snackbar = true;
    },
    show() {
      return new Promise((resolve, reject) => {
        getChicken().then(req => {
          resolve(req.data.data);
        }).catch((e) => {
          reject(e)
        })
      })
    },
    select({label}) {
      let result = this.typeList.find(item => item.value.toLowerCase() === label.split('-')[0].toLowerCase())
      if (!result) return require('@/assets/jetbrains/default.png');
      return result.label;
    }
  }
}
</script>

<style scoped>
</style>
